














import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import BaseIcon from "@/components/BaseIcon";

@Component({ name: "ConfirmCodeView", components: { BaseIcon } })
export default class ConfirmCodeView extends Vue {
  @Prop({ required: true, type: Boolean })
  public readonly loading!: boolean;

  @Prop({ required: true, type: Boolean })
  public success = false;
}
